import styled from "styled-components"
import { Link as RouterLink } from 'react-router-dom';
import { purpleColors, slateColors, Container } from '../ContentPages/AppLandingPage/styles';
import { useTranslation } from 'react-i18next';

const FooterElement = styled.footer`
  background: ${slateColors[900]};
  color: ${slateColors[400]};
  padding: 2rem 1rem;
  width: 100%;
  box-sizing: border-box;
  
  @media (min-width: 640px) {
    padding: 2.5rem 1.5rem;
  }
  
  @media (min-width: 768px) {
    padding: 3rem 3rem;
  }
`;

const FooterContainer = styled(Container)`
  max-width: 80rem;
`;

const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const LogosSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  
  @media (min-width: 768px) {
    flex-wrap: nowrap;
  }
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;
  
  img {
    height: 1.75rem;
    width: auto;
    filter: brightness(0) invert(1);
    opacity: 0.9;
  }
`;

const LinksSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 2rem;
  justify-content: center;
  
  @media (min-width: 640px) {
    gap: 1rem 2.5rem;
  }
  
  @media (min-width: 768px) {
    gap: 0.75rem 2rem;
  }
  
  @media (min-width: 1024px) {
  }
`;

const NavLink = styled(RouterLink)`
  color: ${slateColors[400]};
  text-decoration: none;
  font-size: 0.8125rem;
  font-weight: 400;
  transition: color 0.2s;
  padding: 0.25rem 0;
  
  @media (min-width: 640px) {
    font-size: 0.875rem;
  }
  
  &:hover {
    color: white;
  }
  
  &:active {
    color: ${purpleColors[400]};
  }
`;

const FundingSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
`;

const FundedByText = styled.span`
  color: ${slateColors[500]};
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  
  @media (min-width: 640px) {
    font-size: 0.8125rem;
  }
`;

const ImecLogoLink = styled.a`
  display: inline-block;
  text-decoration: none;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 0.8;
  }
  
  img {
    height: 1.75rem;
    width: auto;
    filter: brightness(0) invert(1);
    opacity: 0.9;
  }
`;

const FooterBottom = styled.div`
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid ${slateColors[700]};
  text-align: center;
  font-size: 0.75rem;
  color: ${slateColors[500]};
  line-height: 1.5;
  
  @media (min-width: 640px) {
    font-size: 0.8125rem;
  }
`;

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <FooterElement>
      <FooterContainer>
        <FooterContent>
          <LogosSection>
            <LogoSection>
              <img src="/images/chuuchuu-logo.svg" alt="chuuchuu logo" />
            </LogoSection>
            
            <FundingSection>
              <FundedByText>{t('footerSection.footer.supportedBy')}</FundedByText>
        <ImecLogoLink href="https://www.imecistart.com/" target="_blank" rel="noopener noreferrer">
                <img src="/images/imec_istart_logo.svg" alt="imec istart logo" />
        </ImecLogoLink>
            </FundingSection>
          </LogosSection>
          
          <LinksSection>
            <NavLink to="/app">{t('footerSection.footer.app')}</NavLink>
            <NavLink to="/data">{t('footerSection.footer.data')}</NavLink>
            <NavLink to="/contact">{t('footerSection.footer.contact')}</NavLink>
            <NavLink to="/2025wrapped">{t('footerSection.footer.wrapped2025')}</NavLink>
            <NavLink to="/terms">{t('footerSection.footer.terms')}</NavLink>
            <NavLink to="/privacy">{t('footerSection.footer.privacy')}</NavLink>
            <NavLink to="/imprint">{t('footerSection.footer.imprint')}</NavLink>
          </LinksSection>
        </FooterContent>
        
        <FooterBottom>
          <p>
            {t('footerSection.footer.copyright')} {currentYear} chuuchuu BV<br />
            {t('footerSection.footer.antwerpBelgium')}
          </p>
        </FooterBottom>
      </FooterContainer>
    </FooterElement>
  );
};

export default Footer;
